import api from './api.js'
import axios from 'axios';
import router from './index';
axios.defaults.timeout = 5000; //请求超时5秒
// axios.defaults.baseURL = 'api'; //请求base url
// axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded'; //设置post请求是的header信息
axios.defaults.headers.post['Content-Type'] = 'application/json'; //设置post请求是的header信息

// "Content-Type":"application/json"
// axios.defaults.headers['Content-Type'] = 'text/plain'; //设置post请求是的header信息
axios.defaults.withCredentials = true


//http request 拦截器
axios.interceptors.request.use(
	config => {
		let token = sessionStorage.getItem('token')
		if (token) { // 判断是否存在token，如果存在的话，则每个http header都加上token
			config.headers = {
				'X-token': token
			}
		}

		return config
	},
	err => {
		return Promise.reject(err)
	}
)

axios.interceptors.response.use(
	response => {
		if (response.data.code === 4003) {
			Toast({
				mes: '您没有权限操作！',
				timeout: 1500,
				callback: () => {
					router.go(-1);
				}
			});

			return false;
		}
		if (response.data.code === -1) {
			localStorage.removeItem('token')
			router.push({
				path: "/login",
				querry: {
					redirect: router.currentRoute.fullPath
				} //从哪个页面跳转
			})
		}
		return response
	},
	err => {
		if (err.code === 'ECONNABORTED' && err.message.indexOf('timeout') !== -1) {
			Toast({
				mes: '网络异常，连接超时...',
				timeout: 1500
			});
		}
		return Promise.reject(err)
	}
)
/**
 * 封装get方法
 * @param url
 * @param data
 * @returns {Promise}
 */

export function get(apiName, params = '', headers = {}) {
	return new Promise((resolve, reject) => {
		axios.get(api[apiName]+params, {
			// params: params,
			headers: headers
		})
			.then(response => {
				resolve(response.data);
			})
			.catch(err => {
				reject(err)
			})
	})
}
export function getTwo(apiName, params = {}, headers = {}) {
	return new Promise((resolve, reject) => {
		axios.get(api[apiName], {
			params: params,
			headers: headers
		})
			.then(response => {
				resolve(response.data);
			})
			.catch(err => {
				reject(err)
			})
	})
}
/**
 * 封装post请求
 * @param url
 * @param data
 * @returns {Promise}
 */

export function post(apiName, data = {}, headers = {}) {
	return new Promise((resolve, reject) => {
		axios.post(api[apiName], data,{
			headers: headers
		})
			.then(response => {
				resolve(response.data);
			}, err => {
				reject(err)
			})
	})
}


// WEBPACK FOOTER //
// ./src/router/request.js


// WEBPACK FOOTER //
// ./src/router/request.js